var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1164 26.0001C10.9555 25.9996 10.7966 25.9641 10.6506 25.896L5.99175 23.465C4.80067 22.8819 3.72604 22.0844 2.82115 21.1121C1.06103 19.158 0.0756624 16.6231 0.0517578 13.988V5.36907C0.0529886 4.87802 0.207098 4.39963 0.492543 4.00099C0.777988 3.60235 1.18044 3.3034 1.6435 3.14604L10.1976 0.143045C10.7139 -0.0323008 11.2731 -0.0323008 11.7894 0.143045L20.3823 3.04202C20.8481 3.19423 21.2547 3.48927 21.5449 3.8857C21.8351 4.28213 21.9942 4.76001 22 5.25204V13.8841C22.0085 16.5165 21.0554 19.0605 19.3211 21.0341C18.4255 22.0089 17.3597 22.8108 16.1765 23.4001L11.5564 25.883C11.4176 25.9595 11.2618 25.9998 11.1035 26.0001",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1202 16.0159C9.99139 16.0199 9.86312 15.9979 9.74304 15.951C9.62297 15.9041 9.51354 15.8333 9.42133 15.7429L6.94956 13.3509C6.78193 13.1764 6.68823 12.9434 6.68823 12.7009C6.68823 12.4584 6.78193 12.2254 6.94956 12.0509C7.13686 11.8735 7.38453 11.7748 7.64192 11.7748C7.8993 11.7748 8.14698 11.8735 8.33428 12.0509L10.1202 13.7799L14.4813 9.4639C14.6649 9.28443 14.911 9.18405 15.1672 9.18405C15.4234 9.18405 15.6695 9.28443 15.8531 9.4639C16.0207 9.63839 16.1144 9.87141 16.1144 10.1139C16.1144 10.3564 16.0207 10.5894 15.8531 10.7639L10.806 15.769C10.6242 15.9519 10.3775 16.0547 10.1202 16.0549",
    fill: "#191A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDone);
export default __webpack_public_path__ + "static/media/shield_done.690f44e1c6555af1e240a62549dc406b.svg";
export { ForwardRef as ReactComponent };